import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventEditor } from "../event-page-models/event-editor";
import { EventSerializerService } from "../../../_services/eventsServices/eventSerializer.service";
import { PostEventModel } from "../event-page-models/post-event-model";
import { EventFormStatusEnum } from "../event-page-models/event-form-status.enum";
import { PutEventModel } from "../event-page-models/put-event-model";
import { InternalEventFormModel } from "../event-page-models/internal-event-form-model";
import { EventValidationService } from "../../../_services/eventsServices/eventValidation.service";
import { ParentQuestion } from "../event-page-models/parent-question";
import { parentEventMegaFormValues } from "../tests/fixtures/parentEventMegaFormValues";
import { devToastMessage } from "../../../_helpers/devToastMessage";

import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { LoggerService } from "../../../modules/logger/logger.service";
import { debounceTime, distinct, distinctUntilChanged } from "rxjs/operators";
import { EventFormInitialData } from "../event-page-models/event-form-initial-data";

@Component({
  selector: "create-parent-event-form",
  templateUrl: "./create-parent-event-form.component.html",
  styleUrls: ["./create-parent-event-form.component.scss"],
})
export class CreateParentEventFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("modalEventId") public modalEventId: "new" | string;
  @Input("isCloneEvent") public isCloneEvent: boolean = false;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();
  public isLoading: boolean = true;

  public parentEventMainDetailsForm: FormGroup = new FormGroup({
    parentEventId: new FormControl(""),
  });
  public parentEventBudgetSection: FormGroup = new FormGroup({
    budgetSectionId: new FormControl(""),
    budgetSectionDescription: new FormControl(""),
  });
  public parentEventMegaForm: FormGroup = new FormGroup({});
  public isNewEvent: boolean = true;
  public disableSave: boolean = false;

  public specificEventName: string = "ארוע";

  constructor(
    protected eventsService: EventsService,
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected logger: LoggerService,
    protected sessionManagerService: SessionManagerService
  ) {}

  public static getPriceChangesFromForm(megaForm: any): Array<{
    childEventIndex: number;
    priceChanges: Array<{
      id: number;
      priceChangeNewPrice: string;
      priceChangeDate: string;
    }>;
  }> {
    const ActiveChildEvents =
      megaForm.controls["AllChildEvents"].controls["ActiveChildEvents"];

    return ActiveChildEvents.controls.map((childEvent, i) => {
      return {
        childEventIndex: i,
        priceChanges: childEvent["controls"][
          "eventFormPriceChanges"
        ].controls.map((pc) => pc.value),
      };
    });
  }

  public ngOnInit(): void {
    this.initParentEventForm(this.modalEventId).then();
    this.parentEventMegaForm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        )
      )
      .subscribe((formData: InternalEventFormModel) => {
        this.eventsService.updateEventFormData(formData);
      });
  }

  public async devAutoAction() {
    devToastMessage();
    const randNant =
      `${this.specificEventName} ` + Math.floor(Math.random() * 1000);
    const data = parentEventMegaFormValues;
    data.parentEventMain.parentEventDetails.eventName = randNant;
    this.parentEventMegaForm.patchValue(parentEventMegaFormValues);
  }

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {
    this.eventsService.resetAllEditDataData();
  }

  public navigateForm(number: number) {
    const tabNumber = +this.formTabSet.activeId.replace("tab-", "");
    const newTabNumber = tabNumber + number;

    if (newTabNumber < 1 || newTabNumber > 5) {
      return;
    }
    this.formTabSet.select(`tab-${newTabNumber}`);
  }

  public async buildMegaFormObject() {
    const allParentQuestions = await new Promise((resolve, reject) => {
      this.eventsService
        .getAllQuestions()
        .subscribe((questions) => resolve(questions));
    });
    const allPermittedUsers: EventEditor[] = (await new Promise(
      (resolve, reject) => {
        this.eventsService
          .getAllPermittedUsers()
          .subscribe((users) => resolve(users as EventEditor[]));
      }
    )) as EventEditor[];

    const megaFormData = JSON.parse(
      JSON.stringify(this.parentEventMegaForm.value)
    );

    const allPriceChanges =
      CreateParentEventFormComponent.getPriceChangesFromForm(
        this.parentEventMegaForm
      );
    megaFormData.AllChildEvents.ActiveChildEvents.forEach((childEvent, i) => {
      const priceChangesForChildEvent = allPriceChanges.find(
        (pc) => pc.childEventIndex === i
      );
      if (priceChangesForChildEvent) {
        childEvent.priceChanges = priceChangesForChildEvent.priceChanges;
      }
    });

    megaFormData.parentEventParentQuestions = allParentQuestions;
    megaFormData.parentEventAllPermittedUsers = allPermittedUsers.filter(
      (u) => u.canEditEvent
    );
    return megaFormData;
  }

  public async submit() {
    const megaFormData = await this.buildMegaFormObject();

    const serializedMegaFormWithoutAllOrgans =
      EventSerializerService.serializeEventFormToServerPost(megaFormData);

    const allInitialData = this.eventsService.eventFormInitialData$.getValue();
    const serializedMegaForm =
      EventSerializerService.addMissingOrgansToEventForm(
        serializedMegaFormWithoutAllOrgans,
        allInitialData
      );

    const validationErrors = this.validateMegaForm(
      serializedMegaForm,
      allInitialData.formStatus,
      megaFormData.parentEventParentQuestions || []
    );

    if (validationErrors.length) {
      this.showValidationErrors(validationErrors);
      return;
    }
    let saveResponse;

    this.disableSave = true;
    if (allInitialData.formStatus === EventFormStatusEnum.New) {
      saveResponse = await this.eventsService.saveNewEvent(serializedMegaForm);
    } else if (allInitialData.formStatus === EventFormStatusEnum.Update) {
      const putEventModel: PutEventModel = {
        ...serializedMegaForm,
        id: allInitialData.eventFormParentEventData.id,
      };

      saveResponse = await this.eventsService.saveUpdateExistingEvent(
        putEventModel
      );
    } else if (allInitialData.formStatus === EventFormStatusEnum.Copy) {
      saveResponse = await this.eventsService.saveNewEvent(serializedMegaForm);
    }
    let textToAdd = "";
    if (
      saveResponse.data &&
      saveResponse.data.events_not_deleted_due_to_payments &&
      saveResponse.data.events_not_deleted_due_to_payments.length > 0
    ) {
      const numberOfEventsNotDeleted =
        saveResponse.data.events_not_deleted_due_to_payments.length;
      if (numberOfEventsNotDeleted === 1) {
        textToAdd = "\n" + `אחד התמחורים לא נמחק עקב תשלומים קיימים`;
      } else {
        textToAdd =
          "\n" +
          ` ${saveResponse.data.events_not_deleted_due_to_payments.length} ארועים לא נמחקו עקב תשלומים קיימים  `;
      }
    }
    //events_not_deleted_due_to_payments
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    if (saveResponse.success) {
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "סיום",
        modalText:
          `ה${this.specificEventName} ${serializedMegaForm.name} נשמר בהצלחה!` +
          textToAdd,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        this.closeParentEventModal();
      });
      return;
    } else {
      const isDisconnected =
        saveResponse.error && saveResponse.error.status === 401;

      const errorMessage =
        await EventValidationService.convertServer400ErrorsToReadableText(
          saveResponse.error
        );
      const modalText = isDisconnected
        ? "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש."
        : ` השמירה נכשלה. פרטים:   ${"\n" + errorMessage}`;
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        if (isDisconnected) {
          this.closeParentEventModal();
          setTimeout(() => this.router.navigate(["/login"]), 1000);
        }
      });
      this.disableSave = false;
    }
  }

  public async closeParentEventModal() {
    this.modalAction.emit("save");
  }
  public async closeParentEventModalWithCloseButton() {
    this.modalAction.emit("close");
  }
  public skipAndSave(number: number) {
    this.submit().then();
  }

  public async devKeyDown($event: KeyboardEvent) {}

  protected async initParentEventForm(parentEventId: string) {
    if (!parentEventId && this.modalEventId) {
      parentEventId = this.modalEventId;
    }

    if (parentEventId !== "new") {
      this.isNewEvent = false;
      const eventInitPromise: Promise<EventFormInitialData> = this.isCloneEvent
        ? this.eventsService.cloneExistingEventFormInitialData(parentEventId)
        : this.eventsService.getExistingEventFormInitialData(parentEventId);

      eventInitPromise
        .then((eventFormInitialData) => {
          if (eventFormInitialData.eventFormParentEventData.budget_item_line) {
            this.parentEventBudgetSection.patchValue({
              budgetSectionId:
                eventFormInitialData.eventFormParentEventData.budget_item_line
                  .id,
              budgetSectionDescription:
                eventFormInitialData.eventFormParentEventData.budget_item_line
                  .description,
            });
          }

          this.isLoading = false;
        })
        .catch((err) => {
          this.handleError(err);
        });
    } else {
      try {
        await this.eventsService.getCreateEventFormInitialData();
        this.isLoading = false;
      } catch (err) {
        this.handleError(err);
      }
    }
    this.buildMegaForm();
  }

  protected buildMegaForm() {
    this.parentEventMegaForm.addControl(
      "parentEventMain",
      this.parentEventMainDetailsForm
    );
    this.parentEventMegaForm.addControl(
      "parentEventBudgetSection",
      this.parentEventBudgetSection
    );
  }

  protected handleError(err: any) {
    this.logger.error(err);
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך את ה${this.specificEventName}   `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }

  protected showValidationErrors(validationErrors: string[]) {
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText: `לשם שמירת ה${this.specificEventName}: ${validationErrors.join(
        ", "
      )}`,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  protected validateMegaForm(
    postEventFormData: PostEventModel,
    formStatus: EventFormStatusEnum,
    allParentQuestions: ParentQuestion[]
  ): string[] {
    return EventValidationService.validateMegaForm(
      postEventFormData,
      formStatus,
      allParentQuestions,
      this.specificEventName
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form/create-parent-event-form.component.ts